import {
  IRequestForChangesTicket,
  IMainViewRequestForChangesTicket,
  IAssessmentRequestForChangesTicket,
  IApprovalsRequestForChangesTicket,
  ISchedulingRequestForChangesTicket,
  IAffectedRequestForChangesTicket,
  IPlanningRequestForChangesTicket,
  IImplementationRequestForChangesTicket,
  IChangeTasksRequestForChangesTicket
} from './IRequestForChangesTicket';
import { get } from 'lodash';

export class RequestForChangesTicket implements IRequestForChangesTicket {
  public guid: string;
  public relations: any;
  public id: string;
  public name: string;
  public creationTime: string;
  public topicType: string;
  public service: any;
  public main: any;
  public details: any;
  public ticketId?: string;
  public stateFinal: string;
  public stateId: string;
  public mainView?: IMainViewRequestForChangesTicket;
  public assessment?: IAssessmentRequestForChangesTicket;
  public approvals?: IApprovalsRequestForChangesTicket;
  public scheduling?: ISchedulingRequestForChangesTicket;
  public affectedCI?: IAffectedRequestForChangesTicket;
  public planning?: IPlanningRequestForChangesTicket;
  public implementation?: IImplementationRequestForChangesTicket;
  public changeTasks?: IChangeTasksRequestForChangesTicket;

  constructor(
    fromServerTicket: { [key: string]: any },
    statuses: { [key: string]: any },
    prioritys: { [key: string]: any }
  ) {
    const relatedAddressbook = (fromServerTicket.relations || []).find(
      (relation: any) => relation.type === 'CUSTOMER' && relation.related_id === fromServerTicket.addressbook
    );

    const customFieldsValuesMap = statuses[fromServerTicket.state.id];
    this.ticketId = fromServerTicket.id;
    this.id = fromServerTicket.id;
    this.stateFinal = get(fromServerTicket, 'state.final', null),
    this.stateId = get(fromServerTicket, 'state.id', null),
    this.mainView = {
      processId: fromServerTicket.guid,
      priority: prioritys[fromServerTicket.priority],
      shortName: fromServerTicket.name,
      description: fromServerTicket.description,
      changeType: get(fromServerTicket, 'customfields.ChangeType', null),
      primaryContact: get(relatedAddressbook, 'related_record.n_fn', null),
      company: get(fromServerTicket, 'company.org_name', 'null'),
      status: get(fromServerTicket, 'state.name', null),
      category: fromServerTicket.category && fromServerTicket.category[0] && fromServerTicket.category[0].name,
      impact: get(fromServerTicket, 'impact.name', null),
      urgency: get(fromServerTicket, 'urgency.name', null),
      risk: get(fromServerTicket, 'risk.name', null),
      closureCode:
        customFieldsValuesMap && customFieldsValuesMap.ChangeClosureCode && fromServerTicket.customfields &&
        customFieldsValuesMap.ChangeClosureCode[fromServerTicket.customfields.ChangeClosureCode],
      externalReference: get(fromServerTicket, 'customfields.ExternalReference', null)
    };
    this.affectedCI = {
      service: fromServerTicket.service,
      list: [],
      primaryCI: fromServerTicket.ci
    };
    this.changeTasks = {
      list: fromServerTicket.relations
    };
    this.relations = fromServerTicket.relations;
  }
}
